import arrayParser from "../arrayParser"

const asbestosProcessor=(element)=>
{
let assembledElement=""
if (element["Asbestos_type(s):"].length !== 0)
    {
    assembledElement  += " had asbestos exposure"
    }
else 
    {
    let asbestosType=arrayParser(element["Asbestos_type(s):"])
    assembledElement += `had exposure to ${asbestosType} asbestos`
    }

if (element["Without_protective_equipment:"] !== "")
    {
    assembledElement += ` ${(element["Without_protective_equipment:"] === "yes" ? " without" : "with" )} protective equipment`
    }

if (element["Frequency_of_exposure:"] !== "")
    {
    assembledElement += ` ${element["Frequency_of_exposure:"].toLowerCase()}`
    }

if (element["Exposure_over_(years)"] !== "")
    {
    assembledElement += ` over ${element["Exposure_over_(years)"]} years`
    }

if (element["Last_exposed_(years)"] !== "")
{
assembledElement += ` up until ${element["Last_exposed_(years)"]} years ago`
}

return (assembledElement)
}

export default asbestosProcessor